(function () {
  'use strict';

  angular
    .module('user.agreements')
    .config(config);

  function config($stateProvider, configOptions) {
    $stateProvider
      .state('user.agreements', angular.extend({}, configOptions.defaultStateParams, {
        url: '/agreements',
        templateUrl: 'user/user.tpl.html',
        controller: 'UserCtrl',
        controllerAs: 'user',
        onEnter: ['RouterHelper', function (RouterHelper) {
          RouterHelper.activateTab('user', 'agreements');
        }]
      }));
  }
}());
